/**
 @ngdoc directive
 @name disableAfterClick

 @description
 Directive for disabling an input after the user has clicked on it. This is only useful for non-input buttons using an ng-click to trigger location.href.

 @example screeningCase/edit.gsp

 @usage
 <button disable-after-click ng-click="window.location.href='${createLink(action:'requestToDbsUpdateService', id:screeningCase?.id)}';return false;"></button>
 */

(function () {
  "use strict";
  var disableAfterClick = function ($timeout) {
    return {
      restrict: "A",
      link: function ($scope, $element, $attrs) {
        $element.on("click", function() {
            $timeout(function () {
              $attrs.$set("disabled", "disabled");
            });
        });
      },
    };
  };
  disableAfterClick.$inject = ["$timeout"];
  angular.module("app").directive("disableAfterClick", disableAfterClick);
})();
